export default __webpack_public_path__ + "static/media/logoOnEarthStudio.4856ca25.png";